export default __webpack_public_path__ + "images/9dac5fe1ed20f2facb0bf271f900b5d1-republican_party.webp";